export const CanalIngreso = [
    {
        codigoConsulta: "N",
        texto: "DIRECTO"
    }, {
        codigoConsulta: "S",
        texto: "COMERCIAL"
    }];

export const obtenerCodigoEnvio = (codigoConsulta: string) => {
    return CanalIngreso.find(canal => canal.codigoConsulta === codigoConsulta);
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/gestion_empresas_trasladables/modelo/CanalIngreso.ts